// Shows a fixed add-to-cart bar once the main add-to-cart button has scrolled above the viewport.
// The bar is a manual popover (top layer) inside the product form, so its submit button posts the same variant.
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const sentinel = form?.querySelector('[data-sticky-atc-sentinel]');
    if (!sentinel || typeof this.showPopover !== 'function') return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      const open = this.matches(':popover-open');
      if (show && !open) this.showPopover();
      if (!show && open) this.hidePopover();
    });
    this.#observer.observe(sentinel);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
